export type ProjectTenantView = "resolved" | "associating" | "redirect";
export type ProjectTenantAction = "clear" | "setProject" | "mutate" | "none";

interface ProjectTenantStateInput {
    hasTenant: boolean;
    pendingTenantId: string | undefined;
    isProjectFetching: boolean;
    isAssociateError: boolean;
    isAssociateSuccess: boolean;
    isAssociatePending: boolean;
}

interface ProjectTenantState {
    view: ProjectTenantView;
    action: ProjectTenantAction;
}

export function deriveProjectTenantState({
    hasTenant,
    pendingTenantId,
    isProjectFetching,
    isAssociateError,
    isAssociateSuccess,
    isAssociatePending
}: ProjectTenantStateInput): ProjectTenantState {
    if (hasTenant) {
        return { view: "resolved", action: pendingTenantId !== undefined ? "clear" : "none" };
    }

    const associationStalled = isAssociateSuccess && !isProjectFetching;

    if (associationStalled) {
        return { view: "redirect", action: "none" };
    }

    if (pendingTenantId === undefined || isAssociateError) {
        return { view: "redirect", action: "setProject" };
    }

    if (!isAssociatePending && !isAssociateSuccess) {
        return { view: "associating", action: "mutate" };
    }

    return { view: "associating", action: "none" };
}
